import { HttpHeader } from '../utils/HttpHeader';
import { HttpRequester } from '../utils/HttpRequester';
import { Urls } from "../utils/Urls";
import { TokenService } from './TokenService';
import { TaxExemption } from '../models';
import { TaxExemptionRequest, UpvestHistoryValueRequest } from '../requests';
import { formatDate } from '../Formatters';
import moment from 'moment';
import { PricePeriods } from '../contants';
export class InstrumentTaxExemption {
    private static links = Urls.URLS();
    private static requester = HttpRequester.httpRequester();
    private static headers = new HttpHeader();

    public static async getTaxExemptionByAccount(upvestUserId:string):Promise<Array<TaxExemption>>{
        try{
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            let json = await this.requester.get(this.links.getTaxExemptions(upvestUserId),this.headers);
            let response:Array<TaxExemption> = json.data;
            return response;
        }
        catch(err){
            throw err;
        }

    }
    public static async createNewTaxExemption(request:TaxExemptionRequest):Promise<TaxExemption>{
        try{
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            let json = await this.requester.post(this.links.createTaxExemptions(),this.headers,request);
            let response:TaxExemption = json.data;
            return response;
        }
        catch(err){
            throw err;
        }
    }
    public static async updateTaxExemption(request:TaxExemptionRequest,taxExemptionId:string):Promise<TaxExemption>{
        try{
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            let json = await this.requester.put(this.links.deleteEditTaxExemptions(taxExemptionId),this.headers,request);
            let response:TaxExemption = json.data;
            return response;
        }
        catch(err){
            throw err;
        }
    }
    public static async deleteTaxExemption(taxExemptionId:string):Promise<boolean>{
        try{
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            let json = await this.requester.delete(this.links.deleteEditTaxExemptions(taxExemptionId),this.headers);
            return true;
        }
        catch(err){
            throw err;
        }
    }
}